module.exports = "/images/add@3x.png?299e4aa205bf34d7080a04629a6c69ab";